import { Component } from '@angular/core';

@Component({
	selector: 'app-info-row',
	standalone: false,
	templateUrl: './info-row.component.html',
	styleUrls: ['./info-row.component.scss'],
})
export class InfoRowComponent {}
